module.exports = __webpack_public_path__ + "img/icon-stamp.7d37d7ed.svg";